import napStyles from './../nap.json'

export default {
  weight: 700,
  color: napStyles.colors.PrimaryBlack,
  inverseColor: napStyles.colors.PrimaryWhite
}
